module.exports = __webpack_public_path__ + "static/media/Duc_Tran.46950b35.png";